import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 40px;
  filter: none !important;
  background-color: ${({ theme }) => theme.mainBgColor};
  position: relative;

  input {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-md);
    border: 1px solid ${({ theme }) => theme.mainBorderColor};
    border-radius: ${({ radius }) => radius};
    color: var(--color-dark);
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 5px;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
  }

  input:focus ~ label {
    color: ${({ theme }) => theme.mainTextColor};
    transform: translateY(-22px);
  }

  label {
    position: absolute;
    transform: ${({ value }) => value && "translateY(-22px)"};
    bottom: 12px;
    left: 20px;
    font-size: 14px;
    font-weight: var(--font-weight-lg);
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 5;
    color: ${({ theme, value }) =>
      value ? theme.mainTextColor : theme.secondaryTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
  }
`;


const MailInput = ({ labelText, name, handleChange, value }) => {
  return (
    <Container value={value}>
      <input
        type="email"
        id={name}
        onChange={handleChange}
        value={value}
        name={name}
      />
      <label htmlFor={name}>{labelText}</label>
    </Container>
  );
};

export default MailInput;
